import { attr, Model } from 'redux-orm';
import { createAction, createLoadConst, createUpdateConst } from '../util';

export default class FspConfigValues extends Model {
  static get modelName() {
    return 'FspConfigValues';
  }

  static reducer({ type, data }, FspConfigValues) {
    switch (type) {
      case LOAD.SUCCESS:
      case UPDATE.SUCCESS:
        // Handle array of config values from both LOAD and UPDATE responses
        // SDK returnModel returns array directly in data.response
        if (Array.isArray(data.response)) {
          data.response.forEach((configValue) => {
            FspConfigValues.upsert({
              id: configValue.id,
              fspId: configValue.fspId,
              ...configValue,
            });
          });
        } else if (data.response?.fspConfigValues) {
          // Fallback for wrapped response
          data.response.fspConfigValues.forEach((configValue) => {
            FspConfigValues.upsert({
              id: configValue.id,
              fspId: configValue.fspId,
              ...configValue,
            });
          });
        }
        break;

      default:
        break;
    }
  }

  static get fields() {
    return {
      id: attr(),
      fspId: attr(),
      valueItem: attr(),
      offset: attr(),
      href: attr(),
      createdAt: attr(),
      createdUser: attr(),
      insAdminUserId: attr(),
      updateAt: attr(),
      updateUser: attr(),
      updAdminUserId: attr(),
    };
  }
}

const name = FspConfigValues.modelName;

export const LOAD = createLoadConst(name);
export const UPDATE = createUpdateConst(name);

export const load = createAction(LOAD);
export const update = createAction(UPDATE);
